import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty, isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SortCell from 'components/atoms/GefMui/SortCell';
import { sortTypeTasks } from 'features/other/typeTasks/actions';
import { getSortValueByTaskType } from 'features/other/typeTasks/selectors';

export const TaskTableHeader = ({
	isNotProcessedTask,
	isTask,
	allSelected,
	mainFilterVisible,
	onSelectAll,
	tasks,
	taskTypeId,
}) => {
	const dispatch = useDispatch();
	const sort = useSelector((state) => getSortValueByTaskType(state, taskTypeId));
	const hasRecords = !isEmpty(tasks);

	const handleSort = useCallback(
		(sort) => {
			dispatch(sortTypeTasks(sort, taskTypeId));
		},
		[dispatch, taskTypeId],
	);

	return (
		<TableHead>
			<TableRow>
				<TableCell>
					<div>{getLabelMessage(`tasksOverview:${isTask ? 'taskId' : 'informationId'}`)}</div>
					<div>{getLabelMessage(`tasksOverview:${isTask ? 'taskSubtype' : 'informationSubtype'}`)}</div>
				</TableCell>
				<TableCell>{getLabelMessage('tasksOverview:clientName')}</TableCell>
				<TableCell>
					<SortCell
						hasRecords={hasRecords}
						sortBy="createDate"
						sort={isNil(sort) ? 'createDate,desc' : sort}
						onSort={handleSort}
					>
						{getLabelMessage('tasksOverview:dateCreated')}
					</SortCell>
					<SortCell
						hasRecords={hasRecords}
						sortBy="deadlineDate"
						sort={isNil(sort) ? 'createDate,desc' : sort}
						onSort={handleSort}
					>
						{getLabelMessage('tasksOverview:deadline')}
					</SortCell>
				</TableCell>
				<TableCell>
					<div>{getLabelMessage('tasksOverview:policyNo')}</div>
					<div>{getLabelMessage('tasksOverview:product')}</div>
				</TableCell>
				<TableCell>{getLabelMessage('tasksOverview:address')}</TableCell>
				<TableCell>{getLabelMessage('tasksOverview:policyAdmins')}</TableCell>
				{/*
                    when opening customFilter - we are not resetting quickfilter, but only hiding the selected value
                    thats the reason of these render conditions
                */}
				<TableCell width="220px">
					{isNotProcessedTask && !mainFilterVisible && (
						<Stack
							direction="row"
							sx={{
								justifyContent: 'flex-end',
							}}
						>
							{isNotProcessedTask && !mainFilterVisible && (
								<Link underline="none" onClick={onSelectAll}>
									{getLabelMessage(`tasksOverview:${allSelected ? 'unselectAll' : 'selectAll'}`)}
								</Link>
							)}
						</Stack>
					)}
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

TaskTableHeader.propTypes = {
	allSelected: PropTypes.bool,
	isNotProcessedTask: PropTypes.bool,
	isTask: PropTypes.bool,
	mainFilterVisible: PropTypes.bool,
	onSelectAll: PropTypes.func,
	taskTypeId: PropTypes.number,
	tasks: PropTypes.array,
};
export default TaskTableHeader;
